/* eslint-disable max-len */
// Core
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  useModal,
} from '@stockx/ui';
import { useExperiment } from '@app/experiments';
import { EXPERIMENTS } from '@app/config';
// Constants
import PortfolioItemConstants from '@sell/const/PortfolioItem';

// Util
import AddPortfolioItemModalForm from './AddPortfolioItemModalForm';

const AddPortfolioItemModal = (props) => {
  const { show, setIsModalOpen } = props;
  const { t } = useTranslation();

  const { sx } = useModal();
  const isFavoriteTestEnabled =
    useExperiment(EXPERIMENTS.ab_pirate_product_cell_favorite_web_v1) ===
    'true';

  const follow = t('Follow');
  const favorite = t('Favorite');
  const addToPortfolio = t('Add to Portfolio');

  const [title, setTitle] = useState(addToPortfolio);

  const setTitleFromActionCode = (code) => {
    if (
      Number(code) === PortfolioItemConstants.actions.WANT &&
      isFavoriteTestEnabled
    ) {
      setTitle(favorite);
    } else if (
      Number(code) === PortfolioItemConstants.actions.WANT &&
      !isFavoriteTestEnabled
    ) {
      setTitle(follow);
    } else {
      setTitle(addToPortfolio);
    }
  };

  return (
    <Modal
      isOpen={show}
      onClose={() => setIsModalOpen(false)}
      closeOnOverlayClick
    >
      <ModalOverlay />
      <ModalContent sx={sx.modalContent}>
        <ModalHeader sx={sx.modalHeader}>{title}</ModalHeader>
        <ModalCloseButton sx={sx.modalCloseButton} />
        {
          // We move ModalBody/ModalFooter into the Form component itself so we can use our design system modal layout. Once collect modal form logic is refactored, we can move back out here.
        }
        <AddPortfolioItemModalForm
          {...props}
          setTitleFromActionCode={setTitleFromActionCode}
        />
      </ModalContent>
    </Modal>
  );
};

export default AddPortfolioItemModal;
